import React from "react";

// 空状態の表示。既定はテーブル空（mp-tablewrap でラップ）。
// bare を渡すとラッパー無しの mp-empty のみ（TODOリスト等の非テーブル用）。
export default function EmptyState({ children, bare }) {
  const inner = <div className="mp-empty">{children}</div>;
  return bare ? inner : <div className="mp-tablewrap">{inner}</div>;
}
